import { Container, Grid, Image, Select, Form, TextArea } from "semantic-ui-react"
import { setLetterJsOfficer, setClosureLetterInvestmentData } from "../../redux/projectSlice"
import { useDispatch, useSelector } from "react-redux"
import signature from "../../assets/signature.png"
import logo from "../../assets/logo.png"
import footer from '../../assets/footerLetterNew.png'
import '../../css/letters.css'

const ClosureLetter = () => {
    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project)

    const handleSelectChange = (e, data) => {
        dispatch(setLetterJsOfficer(data.value));
    }

    const handleTextAreaChange = (e, data) => {
        console.log('Setting closure letter investment data:', data.value);
        dispatch(setClosureLetterInvestmentData(data.value));
    }

    const renderHeaderDestination = () => {
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        
        return (
            <div>
            <Grid>
                <Grid.Row >
                    <Grid.Column width={10}>
                    </Grid.Column>
                    <Grid.Column width={6}>
                        <Container textAlign='left'>
                            <p >
                            <span className="text-accent">{contact.title} {contact.firstName} {contact.lastName}<br /></span>
                                {lp.nameInEnglish}<br />
                                {lp.addresses[0].street} {lp.addresses[0].houseNumber}<br />
                                {lp.addresses[0].postalCode} {lp.addresses[0].city}<br />
                                {lp.addresses[0].country}<br />
                            </p>
                            <div className="espace-haut">
                                {/* show current date au format xx month xxxx */}
                                <span className="text-accent">Lille, {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                            </div>
                        </Container>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            </div>
        )
    }

    const renderLetter = () => {
        const letter = projectState.letter
        const project = projectState.project
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        const legalRepresentative = lp.contacts.filter(contact => contact.type === 'LegalRepresentative')[0]
        const selectedJsOfficer = projectState.jsOfficers.filter(jsOfficer => jsOfficer.value === letter?.jsOfficer)

        return (
            <Container textAlign='justified' className="espace-haut">
                <h3>Subject: Project {project.customIdentifier} - {project.acronym} - closure letter</h3>
                <p>Dear {contact.title} {contact.lastName},</p>
                <p>The above-mentioned project has now come to the end of its implementation. 
                    It was assessed based on the information and the data collected during its lifetime and the Joint Secretariat concluded that the closure could take place. 
                    The final ERDF payment was made on {new Date(projectState.lastPaymentDate).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })}.</p>
                <p><u>We would like to remind you of the following obligations</u> arising from the Subsidy Contract or the European Regulations:</p>
                <ul>
                    <li>In line with article 6 of the Subsidy Contract, all project partners must keep all supporting documents<sup>1</sup> (such as invoices, contracts, public procurement files, etc.) 
                        relating to the project for a five-year period (known as a ‘retention period’) starting from 31 December of the year in which the Managing Authority/Joint 
                        Secretariat made the last payment to the lead partner. As the MA/JS made the last payment on {new Date(projectState.lastPaymentDate).toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}, 
                        the supporting documents must be retained until {new Date(new Date(projectState.lastPaymentDate).getFullYear() + 5, 11, 31).toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}.
                        </li>
                    <div className="footnotes" style={{ marginTop: "8em", fontSize: "0.9em", borderTop: "1px solid black" }}>
                    <p>
                        <sup>1</sup> The following rules apply to the archiving of documents:
                    </p>
                    <ul>
                        <li>The documents must be kept either in the form of the originals, or certified true copies of the originals, or on commonly accepted data carriers including electronic versions of original documents or documents existing in electronic version only.</li>
                        <li>Where documents exist in electronic form only, the computer systems used must meet accepted security standards that ensure that the documents held comply with national legal requirements and can be relied on for audit purposes.</li>
                    </ul>
                    </div>    
                    <li>If any state aid was granted (de minimis or GBER) to any partner or final beneficiary, 
                        all the related documentation must be made available for 10 years from the date of granting state aid.</li>
                    <p>Other, possibly longer statutory archiving periods, as required by national law, remain unaffected by the rules mentioned above.</p>
                </ul>

                <p>Representatives of the Managing Authority/Joint Secretariat, Audit Authority, Group of Auditors, auditing bodies of the Member States, 
                    authorised officials of the European Commission and the European Court of Auditors are entitled to examine all relevant documentation and accounts of the project even after its closure.</p>
                <p>Furthermore, the project must ensure the durability of their investments. A project with investments may have to repay the ERDF contribution if, 
                    within five years of the final payment to the project, it is subject to any of the following:</p>
                
                <ul>
                <li>the productive activity ceases or is relocated outside the NUTS2 region in which it received support</li>
                    <li>a change in ownership takes place, giving a firm or a public body an undue advantage</li>
                    <li>a substantial change affecting its nature, objectives, or implementation conditions, undermining the original objectives.</li>
                
                <p>Project partners are obligated to inform the Joint Secretariat where any of the above conditions are not met.</p>
                </ul>

                <div style={{marginBottom:'2em' }}>
                    <Form>
                        <TextArea className="invisible-print" onChange={handleTextAreaChange} value={letter?.closureInvestmentData}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.closureInvestmentData}</p>
                </div>
                
                <p>Please ensure that both the lead partner and all the project partners comply fully with the above obligations.</p>
                <p>Even if the implementation of the project is finished, the NWE Programme still expects that your project will bring long-lasting effects to the Programme territory 
                    (see section 2 and 6 of the Programme Manual). 
                    Around 18 months after the project closure, the Secretariat and/or the Contact Points are planning to get in touch with you to get more information on this aspect.</p>
                <p>We would like to thank you for your cooperation during the project implementation phase.</p>
                <p>Please do not hesitate to contact us <Select placeholder="Select officer" defaultValue={selectedJsOfficer} options={projectState.jsOfficers} className="invisible-print margin-top-bottom-10" onChange={handleSelectChange} /> 
                    {letter?.jsOfficer ? <span className="invisible-screen">{letter?.jsOfficer[0]} - {letter?.jsOfficer[1]} </span> : <span className="error-accent">Please select an Officer</span>} to discuss any queries you may have or just to keep us informed of the latest developments of your project and partnership.</p>
                <p>Kind regards,</p>
                <Image src={signature} size='small' className="espace-haut-large" />
                <p>David Grzegorzewski <br/>
                Programme Director
                </p>
                <p>P.S. We kindly ask you to provide a copy of this document to your legal representative {legalRepresentative.title} {legalRepresentative.firstName} {legalRepresentative.lastName}</p>
            </Container>
        )
    }

    return (
        <div className="margin-notification-letter">
            <table>
                <thead>
                    <div className="print-margin-top-15mm"></div>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <Container className="closure-letter-logo">
                                <Image src={logo} size='medium' />
                            </Container>
                            <Container textAlign="left">
                                {renderHeaderDestination()}
                            </Container>
                            {renderLetter()}
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr className="footer">
                        <td>
                            <Image src={footer} />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div style={{
                                height: 80,
                            }}>

                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
}

export default ClosureLetter;